/**
 * Created by mauget on 3/2/16.
 */

// SettingsLicenseView.js

import $ from 'jquery';
import _ from 'lodash';

import NotificationService from 'NotificationService.js';
import RestService from 'RestService.js';

import eventBus  from 'EventBus.js';
import constants        from 'Constants.js';
import BaseTableView from 'properties/BaseTableView.js'
import contentTemplate  from 'dashboard/settings/license-view.ejs';
import util from 'util/Util.js';
import PopupWrapperService from 'PopupWrapperService';

class SettingsLicenseView extends BaseTableView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = contentTemplate;
        this.gridEl = constants.PROP_MAIN_TABLE;

        this.events = {
            'click #sUpgrade':'upgradeAccount',
            'click #sRefresh':'refreshLicenseDetails',
            'click #goToSettings': 'goToSettings', 
            'click #goToAccountSettings': 'goToAccountSettings'
        };

        this.model.set({
            colModel: [
                {
                    name: 'description',
                    index: 'description',
                    editable: false
                },
                {
                    name: 'current',
                    index: 'current',
                    editable: false
                },
                {
                    name: 'limit',
                    index: 'limit',
                    editable: false
                },
                {
                    name: 'status',
                    index: 'status',
                    editable: false,
                    classes:'statusWarning'
                }
            ],
            colNames: ['Description', 'Current', 'Limit','Status']
        }, {silent: true});
        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid();})
    }    

    renderGrid(){
        let self = this;
        let gridObject = util.getGridObject(this,{autowidth:true});
        $(this.gridEl).jqGrid(gridObject);

        let accountSettings=this.model.get('accountSettings');
        let fullUsers={
            description:'Full Users',
            current:accountSettings.AdvancedUsersCurrent,
            limit:accountSettings.AdvancedUsersLimit,
            status:util.getMessageWarning(accountSettings.AdvancedUsersWarning)
        };
        let basicUsers={
            description:'Basic Users',
            current:accountSettings.BasicUsersCurrent,
            limit:accountSettings.BasicUsersLimit,
            status:util.getMessageWarning(accountSettings.BasicUsersWarning)};
        let offlineUsers={
            description:'Offline Users',
            current:accountSettings.OfflineUsersCurrent,
            limit:accountSettings.OfflineUsersLimit,
            status:util.getMessageWarning(accountSettings.OfflineUsersWarning)};
        let forms={
            description:'Apps',
            current:accountSettings.FormsCurrent,
            limit:accountSettings.FormsLimit,
            status:util.getMessageWarning(accountSettings.FormsWarning)};
        let reports={
            description:'Reports',
            current:accountSettings.ReportsCurrent,
            limit:accountSettings.ReportsLimit,
            status:util.getMessageWarning(accountSettings.ReportsWarning)};
        let storage={
            description:'Storage',
            current:util.getSizeInMb(accountSettings.StorageCurrent),
            limit:util.getSizeInMb(accountSettings.StorageLimit),
            status:util.getMessageWarning(accountSettings.StorageWarning)};
        //let gridData=[fullUsers,basicUsers,offlineUsers,forms,reports,storage];
        let gridData=[fullUsers,basicUsers,forms,reports,storage];
            _.forEach(gridData, (field, index) => {
                self.fillNewRow(index, field['description'], field['current'], field['limit'],field['status'])
            });
    }

    fillNewRow(index, description, current, limit,status) {
        $(this.gridEl).addRowData(index, {description, current, limit,status});
    }

    upgradeAccount(){
        RestService.getSignUpMethod().then((response)=>{
            let accountPurchaseURL=response.AccountPurchaseURL;
            let currentProfile=RestService.getProfile();
            let urlToRedirect=accountPurchaseURL+'?email='+currentProfile.EmailAddress+'&account='+currentProfile.AccountId;
            // window.open(urlToRedirect,"_blank");
            PopupWrapperService.windowOpen( urlToRedirect,`_blank`);
        }).catch((err)=>{
           NotificationService.error("There was an error retrieving the purchase URL" + err);
        });
    }

    refreshLicenseDetails(ev){
        eventBus.trigger(constants.EV_REFRESH_LICENSE_DETAILS);
    }

    refresh(){
        eventBus.trigger(constants.EV_REFRESH_LICENSE_DETAILS);
    }

    render() {
        const html = this.template( this.model.toJSON() );

        $(this.$el[0]).html( html );
        this.renderGrid();
        this.delegateEvents();
        this.$el.css( 'cursor', 'default' );

        return this;
    }

    remove(){
        $(window).off('resize');
        super.remove();
    }

   goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well_1"]').click();
    }
}

export default SettingsLicenseView;
